import { useRef } from "react";
import { useDrop, useDrag } from "react-dnd";
import Icon from "../../../controls/Icon";

const DragItem = ({
    type,
    onReorder,
    disabled = false,
    index,
    label
}) => {
    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: type,
        hover: (item, monitor) => {
            if (onReorder && !disabled) {
                const dragIndex = item.index;
                const hoverIndex = index;

                if (ref.current && dragIndex !== hoverIndex) {
                    const hoverBoundingRect = ref.current.getBoundingClientRect();
                    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                    const clientOffset = monitor.getClientOffset();
                    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

                    const isDraggingDown = dragIndex < hoverIndex && hoverClientY > hoverMiddleY;
                    const isDraggingUp = dragIndex > hoverIndex && hoverClientY < hoverMiddleY;

                    if (isDraggingDown || isDraggingUp) {
                        onReorder(dragIndex, hoverIndex);
                        item.index = hoverIndex;
                    }
                }
            }
        },
        collect: (monitor) => ({
            handlerId: monitor.getHandlerId(),
        }),
    }, [type, onReorder, index]);

    const [{ isDragging }, drag] = useDrag({
        type,
        item: () => ({
            index,
        }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }, [type]);

    drag(drop(ref));

    return <li key={index} className={`list-group-item d-flex align-items-center ${isDragging ? "" : ""} ${disabled ? 'disabled': ''}`} data-handler-id={handlerId}>
        <div ref={ref} className="moveable me-2" data-handler-id={handlerId}>
            <Icon icon="OpenWith"></Icon>
        </div>
        <label className="small">{label}</label>
    </li>;
};

export default DragItem;